export default __webpack_public_path__ + "static/media/lock.d21065b7.svg";